export default {
  title: '시스템 업그레이드 알림',
  button: '새로고침',
  content: `현재 시스템 버전이 업데이트된 것으로 감지되었습니다.
  페이지를 새로고침하여 사용하십시오.`,
};
